import {
    Badge,
    Box,
    Button,
    Flex,
    Grid,
    Group,
    Input,
    MultiSelectProps,
    rem,
    Select,
    Text
} from "@mantine/core";
import {
    IconBuildingWarehouse,
    IconFileExport,
    IconSearch
} from "@tabler/icons-react";
import {
    MantineReactTable,
    MRT_ColumnDef,
    MRT_PaginationState,
    MRT_RowSelectionState,
    useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";

import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import {
    repositoryMdm,
    repositoryPos,
    styleTableMantine,
} from "../../../../_base/_const/_constVar";
import _breadcrumb from "../../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import LoadingOverlayCustom from "../../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_MDM } from "../../../../config";
import { _localization } from "../../../../config/location";
import { SelectListItemModel } from "../../../../model/SelectListItem";

interface SearchCriteria {
    keySearch?: string;
    branchCode?: string[]; // Mảng chứa các mã chi nhánh
    invCode?: string[]; // Mảng chứa các mã kho
    itemCode?: string[]; // Mảng chứa các mã sản phẩm
    itemKey?: string; // Mã sản phẩm hoặc khóa sản phẩm
}

interface InventoryItem {
    maChiNhanh: string;
    giaTriTon: number;
    giaTriXuat: number;
    tyTrong: number;
};

const SalesInventoryValue = () => {
    const headerRef = React.useRef<HTMLDivElement>(null);
    const [isRefetching, setIsRefetching] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [pagination, setPagination] = useState<MRT_PaginationState>({
        pageIndex: 0,
        pageSize: 20,
    });
    const [visible, { toggle, close, open }] = useDisclosure(false);

    const [height, setHeight] = useState(0);
    const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
    const [data, setData] = useState<InventoryItem[]>([]);
    const [dataInvCode, setDataInvCode] = useState<SelectListItemModel[]>([]);
    const [dataItemCode, setDataItemCode] = useState<SelectListItemModel[]>([]);
    const [rowCount, setRowCount] = useState(0);
    const [dataBranchCode, setDataBranchCode] = useState<any[]>([]);
    const form = useForm<SearchCriteria>({
        mode: "uncontrolled",
        initialValues: {},
    });

    const columns = React.useMemo<MRT_ColumnDef<InventoryItem>[]>(
        () => [
            {
                header: "STT",
                accessorKey: "STT",
                enableColumnActions: false,
                enableSorting: false,
                enableResizing: false,
                Cell: ({ row }) => <>{row?.index + 1}</>,
                size: 50,
            },
            // {
            //     accessorKey: "maChiNhanh",
            //     header: "Mã chi nhánh",
            //     size: 150,
            //     Cell: ({ renderedCellValue, cell, row }) => (
            //         <>
            //             <Badge variant="light" color="violet">
            //                 {renderedCellValue}
            //             </Badge>
            //         </>
            //     ),
            // },
            {
                header: "Tên  chi nhánh",
                size: 300,
                Cell: ({ renderedCellValue, cell, row }) => (
                    <>
                        {dataBranchCode.find(x => x.value === row.original.maChiNhanh)?.label ?? null}
                    </>
                ),
            },
            {
                accessorKey: "giaTriTon",
                header: "Giá trị tồn",
                Cell: ({ renderedCellValue }) => (
                    <>
                        {Number(renderedCellValue).toLocaleString("vi-VN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}
                    </>
                ),
            },
            {
                accessorKey: "giaTriXuat",
                header: "Giá trị xuất",
                Cell: ({ renderedCellValue }) => (
                    <>
                        {Number(renderedCellValue).toLocaleString("vi-VN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}
                    </>
                ),
            },
            {
                accessorKey: "tyTrong",
                header: "Tỷ trọng",
                Cell: ({ renderedCellValue, cell, row }) => <>{renderedCellValue} %</>,
            },
        ],
        [dataBranchCode]
    );
    // Hàm lấy dữ liệu
    const fetchData = async () => {
        setIsLoading(true);
        setIsRefetching(true);
        setIsError(false);

        let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${pagination.pageSize
            }`;
        const search = form.getValues();

        if (search.branchCode && search.branchCode.length > 0) {
            url += `&MaChiNhanh=${search.branchCode}`;
        }
        if (search.keySearch) {
            url += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
        }

        try {
            const response = await repositoryMdm.get(
                `/api/v1/BaoCaoGiaTriTonDoanhThu/get-list${url}`
            );
            if (response && response.success) {
                let result = response.data;
                setData(result);
                setRowCount(response.totalCount);
                table.resetRowSelection();
            }
        } catch (error) {
            setData([]);
            setIsError(true);
            console.error(error);
            return;
        } finally {
            setIsLoading(false);
            setIsRefetching(false);
        }
    };
    // Lấy thông tin chi nhánh
    const DataBranchCodeFC = async () => {
        try {
            const response = await repositoryPos.get(
                `api/v1/TblDmInventory/get-select-branch?auth=true`
            );
            if (response && response.success) {
                const transformedData = response.data
                    .filter((i: any) => i.att2 && i.text)
                    .map((item: any) => {
                        return {
                            value: item.att2,
                            label: item.att2 + " - " + item.text,
                            id: item.value,
                        };
                    });

                setDataBranchCode(transformedData);
            }
        } catch (error) {
            console.error(error);
            return;
        }
    };
    const exportDataExcel = async () => {
        open();
        try {
            let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;
            const search = form.getValues();

            if (search.branchCode && search.branchCode.length > 0) {
                url += `&MaChiNhanh=${search.branchCode}`;
            }
            const baseUrl = `/api/v1/ExportExcel/export-bao-cao-gia-tri-ton-va-doanh-thu${url}`;

            const _url = BASE_API_MDM + baseUrl;
            const token = localStorage.getItem("token");

            const response = await fetch(_url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/vnd.ms-excel",
                    Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
                },
            });
            // Kiểm tra trạng thái HTTP
            if (!response.ok) {
                const errorResponse = await response.json(); // Parse lỗi từ API
                const errorMessage =
                    errorResponse?.message || "Đã xảy ra lỗi khi xuất dữ liệu!";
                throw new Error(errorMessage); // Ném lỗi để xử lý trong `catch`
            }

            const blob = await response.blob();
            const urlss = window.URL.createObjectURL(blob);
            const _name = new Date().toISOString().slice(0, 10);
            let filename = "bao_cao_gia_tri_ton_doanh_thu.xlsx";
            const link = document.createElement("a");
            link.href = urlss;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error: any) {
            console.log("error", error);
            // Hiển thị thông báo lỗi
            NotificationExtension.Fails(
                error.message || "Đã xảy ra lỗi không xác định!"
            );
        } finally {
            close();
        }
    };
    const table = useMantineReactTable({
        columns,
        data,
        enableColumnResizing: true,
        rowCount,
        enableColumnFilters: true,
        enableSorting: true,
        enableColumnActions: true,
        // manualPagination: true,
        enableStickyFooter: true,
        state: {
            // columnFilters,
            // globalFilter,
            isLoading,
            pagination,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
            showSkeletons: isLoading,
            rowSelection,
        },
        manualFiltering: false,
        manualPagination: true,
        manualSorting: false,
        onPaginationChange: setPagination,
        positionToolbarAlertBanner: "bottom",
        initialState: {
            showColumnFilters: false,
            columnPinning: {
                left: ["STT", "maChiNhanh"],
            },
            columnVisibility: { id: false },
            density: "xs",
        },
        enableTopToolbar: false,
        mantineTopToolbarProps: {
            style: {
                borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
                marginBottom: 5,
            },
        },
        localization: _localization,
        getRowId: (row) => row.maChiNhanh,
        mantineTableContainerProps: {
            style: { maxHeight: height, minHeight: height },
        },
        enableStickyHeader: true,
        onRowSelectionChange: setRowSelection,
        mantineTableBodyCellProps: ({ row }) => ({
            style: styleTableMantine,
        }),
        mantineToolbarAlertBannerProps: false
            ? { color: "red", children: "Lỗi tải dữ liệu !" }
            : undefined,

        mantinePaginationProps: {
            showRowsPerPage: true,
            withEdges: true,
            radius: "xl",
            size: "lg",
            rowsPerPageOptions: ["20", "50", "100"],
        },
        paginationDisplayMode: "pages",
        enableColumnPinning: true,
        mantineTableProps: {
            striped: false,
        },
        mantineTableBodyRowProps: ({ row }) => ({
            onClick: row.getToggleSelectedHandler(),
            sx: { cursor: "pointer" },
        }),
    });
    useEffect(() => {
        const headerHeight = headerRef.current?.offsetHeight || 0;
        const handleResize = () => {
            setHeight(window.innerHeight - (165 + headerHeight));
        };

        handleResize(); // Set initial height
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [height]);
    useEffect(() => {
        Promise.all([]).then(() => {
            DataBranchCodeFC();
            fetchData();
        });
    }, [pagination]);
    const renderMultiSelectOption: MultiSelectProps["renderOption"] = ({
        option,
    }) => (
        <Group gap="sm">
            <Text>{dataItemCode.find((x) => x.value === option.value)?.label}</Text>
        </Group>
    );
    return (
        <Box>
            <LoadingOverlayCustom visible={visible} />
            <div ref={headerRef} style={{ width: "100%", marginBottom: "10px" }}>
                <Flex justify={"space-between"} w={"100%"}>
                    <_breadcrumb></_breadcrumb>
                    <Button
                        leftSection={
                            <IconFileExport style={{ width: rem(14), height: rem(14) }} />
                        }
                        onClick={() => exportDataExcel()}
                    >
                        Export Excel
                    </Button>
                </Flex>
                <Grid>
                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <Input
                            placeholder="Nhập tìm kiếm"
                            key={form.key("keySearch")}
                            type="text"
                            leftSection={<IconSearch size={"20"} color="#15aabf" />}
                            onKeyDown={async (e) => {
                                if (e.key === "Enter") {
                                    await fetchData();
                                }
                            }}
                            {...form.getInputProps("keySearch")}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <Select
                            key={form.key("branchCode")}
                            size="sm"
                            placeholder="Mã chi nhánh"
                            searchable
                            clearable
                            data={dataBranchCode}
                            leftSection={<IconBuildingWarehouse size={20} color="#15aabf" />}
                            onClick={() => {
                                if (dataBranchCode.length === 0) {
                                    DataBranchCodeFC();
                                }
                            }}
                            {...form.getInputProps("branchCode")}
                        />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
                        <Button
                            color="blue"
                            variant="outline"
                            onClick={async () => {
                                await fetchData();
                            }}
                        >
                            Tìm kiếm
                        </Button>
                    </Grid.Col>
                </Grid>
            </div>
            <MantineReactTable table={table} />
        </Box>
    );
};

export default SalesInventoryValue;
